<template>
    <BaseMap :layers="layers">
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </BaseMap>
</template>

<script>
import BaseMap from "js/components/base/BaseMap.vue";
import { pointStyleFor } from "js/components/maps/styles";

export default {
    name: "PointMap",
    components: { BaseMap },
    props: {
        geos: {
            type: Array,
            default: () => [],
        },
        geoStyle: {
            type: Function,
            default: (geo) => pointStyleFor(geo),
        },
    },
    computed: {
        layers() {
            return [
                {
                    id: "points",
                    kind: "points",
                    geos: this.geos,
                    style: this.geoStyle,
                },
            ];
        },
    },
};
</script>
